import { defineModule } from '@berky/module-contract'

/**
 * Das Manifest ist die einzige Verbindung zwischen Modul und Shell.
 * Die Shell findet diese Datei selbst — sie muss nirgends eingetragen werden.
 */
export default defineModule({
  id: 'preislisten',
  title: 'Preislisten',
  description:
    'Individuelle Preislisten für Händler und Vertrieb erstellen und gestalten.',
  icon: 'Euro',
  order: 150,
  apiBasePath: '/api/preislisten',

  // Kein scopes-Feld: die Anmeldung an der API macht die Plattform. Sie kennt
  // den Bereich der Umgebung, in der sie gerade läuft — useApiClient() hängt
  // das passende Token von selbst an.

  // Leeres Array: für alle angemeldeten Nutzer sichtbar.
  // Sobald hier eine Rolle steht, sehen nur Nutzer mit dieser Rolle das Modul.
  roles: ['preislisten.nutzer', 'preislisten.admin'],

  routes: () => import('./src/routes'),

  // Optional: eine Kennzahl für die Kachel auf der Startseite.
  // homeWidget: () => import('./src/home-widget'),
})
